import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { MACHINE_ICON_OPTIONS } from "../Dashboard/iconCatalog";
import "./MachineIconPicker.css";

export function machineIconSrc(id) {
  try {
    return require(`../../assets/traccar/online/${id}.svg`);
  } catch (error) {
    return require("../../assets/traccar/online/tractor.svg");
  }
}

export default function MachineIconPicker({ value, onChange, t }) {
  const [open, setOpen] = useState(false);
  const current = MACHINE_ICON_OPTIONS.find(([id]) => id === value) || MACHINE_ICON_OPTIONS[0];

  function choose(id) {
    onChange(id);
    setOpen(false);
  }

  return (
    <div className="machine-icon-picker">
      <button
        type="button"
        className="machine-icon-picker__trigger"
        onClick={() => setOpen(true)}
      >
        <span className="machine-icon-picker__preview">
          <img src={machineIconSrc(current[0])} alt={t(current[1])} />
        </span>
        <span className="machine-icon-picker__meta">
          <span className="machine-icon-picker__name">{t(current[1])}</span>
          <span className="machine-icon-picker__hint">{t("Escolher ícone")}</span>
        </span>
        <FaChevronDown />
      </button>

      {open ? (
        <div
          className="machine-icon-picker__backdrop"
          onClick={() => setOpen(false)}
        >
          <div
            className="machine-icon-picker__dialog"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="machine-icon-picker__dialog-head">
              <h3>{t("Escolher ícone")}</h3>
              <button
                type="button"
                className="machine-icon-picker__close"
                onClick={() => setOpen(false)}
              >
                {t("Fechar")}
              </button>
            </div>
            <p className="machine-icon-picker__lead">
              {t(
                "O ícone aparece no mapa sem fundo. O operador da telemetria é fixo."
              )}
            </p>
            <div className="machine-icon-picker__grid">
              {MACHINE_ICON_OPTIONS.map(([id, label]) => {
                const on = value === id;
                return (
                  <button
                    key={id}
                    type="button"
                    className={`machine-icon-picker__item${on ? " is-on" : ""}`}
                    onClick={() => choose(id)}
                  >
                    <span className="machine-icon-picker__map">
                      <img src={machineIconSrc(id)} alt={t(label)} />
                    </span>
                    <span className="machine-icon-picker__name">{t(label)}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
